"use strict";

exports.__esModule = true;
exports.formatDuration = formatDuration;

function formatDuration(value) {
  var sec_num = parseInt(value, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours) {
    return hours + 'h ' + minutes + 'm ' + seconds + 's';
  }

  if (minutes) {
    return minutes + 'm ' + seconds + 's';
  }

  return seconds + 's';
}